module.exports = __webpack_public_path__ + "media/shared/images/favicon-859ce40fadd563f58a99f0687caa7492.png";